module.exports = __webpack_public_path__ + "static/media/missing-reference@2x.8f215c15.png";